import React from 'react';
import Fa from './fa';

export default function Loading() {
  return <Fa icon="circle-o-notch" spin />;
}
